module.exports = __webpack_public_path__ + "static/media/Dragonite_gaussian2.87094050.png";